import { droneCatalog, DroneMake, DroneModel } from "@nova/constants"
import { config } from "@nova/configuration/browser"

export type DroneImageQuality = "full" | "half"

export function getDroneImageUrl<M extends DroneMake>(
    make: M,
    model: DroneModel<M>,
    quality: DroneImageQuality
) {
    const cdnBase = config.get("cdnBase")

    return `${cdnBase}/aircraft/images/${make}/${model as string}.${quality}.webp`
}

export function getUnknownDroneImageUrl(quality: DroneImageQuality) {
    const cdnBase = config.get("cdnBase")

    return `${cdnBase}/aircraft/images/(unrecognized)/unrecognized.${quality}.webp`
}

export { droneCatalog }
export type { DroneMake, DroneModel }
